import ajax from '@/plugin/ajax'
import utils from '@/common/utils'

export const getMail = function (data) {
    return ajax({
        method: 'get',
        url: '/vipapi/getMail',
        params: data
    })
}

export const getSessionListMail = function (data) {
    return ajax({
        method: 'get',
        url: '/vipapi/getMailSessionList',
        params: data
    })
}

export const getMailListDetail = function (data) {
    return Promise.all([getMail({
        id: data.selectid,
        folderId: data.folderId
    }), getSessionListMail({id: data.id})])
}

export const downloadAll = function (data) {
    return ajax({
        method: 'post',
        url: '/vipapi/attach/downloadAll',
        data: data
    })
}

export const downloadOne = function (data) {
    return ajax({
        method: 'get',
        url: '/vipapi/attach/download',
        params: data
    })
}

export const downloadFile = function (data) {
    return ajax({
        method: 'get',
        url: '/vipapi/downloadOrigin',
        params: data
    })
}

export const addBlackBulk = function (emails) {
    return ajax({
        method: 'post',
        // url: '/vipapi/address/addBlack_v2',
        url: '/vipapi/address/personal_wb',
        data: {
            emails: emails,
            isblack: 1
        }
    })
}
export const spamCleanMail = function (data) {
    return ajax({
        method: 'post',
        url: '/vipapi/spam/cleanMail',
        data: utils.mailParam(data),
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}

export const disposition = function (mailId) {
    return ajax({
        method: 'put',
        url: '/vipapi/disposition',
        data: utils.mailParam({mailId: mailId}),
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}
export const getNearIds = function (folderId, mailId) {
    return ajax({
        method: 'GET',
        url: 'vipapi/getNearIds',
        params: {
            folderId: folderId,
            limit: 1,
            mailId: mailId
        }
    })
}
export const viewOrigin = function (id) {
    return ajax({
        method: 'get',
        url: '/vipapi/viewOrigin',
        params: {id: id}
    })
}



// WEBPACK FOOTER //
// ./src/service/mailDetailService.js